import React, {useState} from "react";
import HilightTable from "../../../../components/HilightTable";
import {Button, Spinner} from "react-bootstrap";
import {withNamespaces} from "react-i18next";
import NetworkDeviceContentIconHelper from "../_helpers/NetworkDeviceContentIconHelper";
import {modalActions} from "../../../../actions/modal.actions";
import {connect} from "react-redux";

const NetworkDeviceContentSelectedTable  = ({ t, list, getSelected, unSelected, showModal, hideModal, deleteItem }) => {

    const [selected, setSelected] = useState([]);

    const openModalRemove = (model) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${model.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: model.id,
            confirmAction: () => {
                deleteItem(model)
                hideModal();
            },
            closeModal: hideModal,
        }, 'confirm')
    };

    const columns = [
        {
            Header: '#',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            accessor: 'id'
        },
        {
            Header: 'type',
            headerClassName: "text-center wrapok",
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            classNameRow: 'text-center',
            Cell: (props) => {
                const data = props.row.original;
                return <NetworkDeviceContentIconHelper type={data.defaultApp?.label} />;
            }
        },
        {
            Header: 'label',
            accessor: 'label',
            Cell: (props) => {
                const data = props.row.original;
                return (
                    <div>
                        <b>{ data.label }</b> &nbsp; <small>ver. { data.version }</small>
                    </div>
                )
            }
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const row = props.row.original;
                return (
                    <div>
                        <Button className="mx-1" variant={"danger"}  onClick={() => openModalRemove(row)} >
                            <i className="fas fa-trash" />
                        </Button>
                    </div>
                )
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h5>{t('no-item-launcher-items')}</h5>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                    getTrProps={(state, rowInfo, columns) => {
                        return {
                            onClick: (e) => {
                                let a = selected.indexOf(rowInfo.index);
                                if (a === -1) {
                                    // this.setState({selected: array.concat(this.state.selected, [rowInfo.index])});
                                    setSelected( [ rowInfo.index]);
                                    getSelected(rowInfo.original);
                                    // Pass props to the React component
                                } else {
                                    setSelected([]);
                                    getSelected(null);
                                }
                            },
                            // #393740 - Lighter, selected row
                            // #302f36 - Darker, not selected row
                            style: {background: (selected.indexOf(rowInfo.index) === -1) ? '#FFFFFF': '#f8f9fa'},
                        }
                    }}
                    // onClickRow={handleClickRow}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )

    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { tableResult }
        </div>
    )
}

const mapDispatchToProps = (dispatch) => ({
    hideModal: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
        dispatch(modalActions.showModal({modalProps, modalType}))
    }
})
export default withNamespaces()(connect(null, mapDispatchToProps)(NetworkDeviceContentSelectedTable));